import { Clock } from "lucide-react";
import { useLanding } from "@/context/LandingContext";

export function SessionPicker({ className = "", idPrefix, light = false }) {
  const { t, events, selectedIndex, setSelectedIndex, lang } = useLanding();
  const r = t.register;
  return (
    <div className={`${className} ${light ? "session-picker-light" : ""}`.trim()} aria-label={r.labels.session} data-testid={`${idPrefix}-picker`}>
      {["English", "Chinese"].map((key) => (
        <div className="session-group" key={key} data-testid={`${idPrefix}-group-${key.toLowerCase()}`}>
          <span className="session-group-label">{r.langTag[key]}</span>
          <div className="session-options">
            {events.map((event, index) =>
              event.language === key ? (
                <button
                  key={event.iso}
                  type="button"
                  className={`session-option ${index === selectedIndex ? "active" : ""}`}
                  aria-pressed={index === selectedIndex}
                  onClick={() => setSelectedIndex(index)}
                  data-testid={`${idPrefix}-option-${index}`}
                >
                  <strong>{event.label[lang]}</strong>
                  <small className="session-option-time" data-testid={`${idPrefix}-option-time-${index}`}><Clock size={11} aria-hidden="true" /> {r.time}</small>
                  <small>{event.speaker}</small>
                </button>
              ) : null,
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
